import styled from "@emotion/styled";

export const DividerTableMenu = styled.div`
  height: 1px;
  background-color: ${prop => prop.theme.colors.secondary.stroke};
  position: relative;
  left: -16px;
  width: calc(100% + 32px);
  margin-bottom: 12px;
  margin-top: 12px;
`;
